/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  addEmployees: {
    id: 'app.components.AdminUsers.addEmployees',
    defaultMessage: 'Add Employees',
  },
  inviteEmployees: {
    id: 'app.components.AdminUsers.inviteEmployees',
    defaultMessage: 'Invite Employees',
  },
  individualEmployee: {
    id: 'app.components.AdminUsers.individualEmployee',
    defaultMessage: 'Add Individual Employee',
  },
  addEmployee: {
    id: 'app.components.AdminUsers.addEmployee',
    defaultMessage: 'Add Employee',
  },
  importEmployees: {
    id: 'app.components.AdminUsers.importEmployees',
    defaultMessage: 'Import Multiple Employees',
  },
  firstName: {
    id: 'app.components.Name.firstName',
    defaultMessage: 'First name',
  },
  middleName: {
    id: 'app.components.AdminGroups.middleName',
    defaultMessage: 'Affix',
  },
  lastName: {
    id: 'app.components.Name.lastName',
    defaultMessage: 'Last name',
  },
  alias: {
    id: 'app.components.EditProfile.aliasLabel',
    defaultMessage: 'Alias',
  },
  aliasPlaceholder: {
    id: 'app.components.EditProfile.aliasPlaceholder',
    defaultMessage: 'E.g., "Miss Jane"',
  },
  group: {
    id: 'app.components.AdminGroups.group',
    defaultMessage: 'Group',
  },
  groups: {
    id: 'app.components.AdminGroups.groups',
    defaultMessage: 'Groups',
  },
  selectFileIntro: {
    id: 'app.components.SelectFiles.selectFileIntro',
    defaultMessage: 'Your file must have the following columns, you can use <a>our template</a>:',
  },
  usersFound: {
    id: 'app.components.AdminUsers.usersFound',
    defaultMessage: 'The following names match with existing employees. Please check the data and update the sheet.',
  },
  usersNotFound: {
    id: 'app.components.AdminUsers.usersNotFound',
    defaultMessage: 'The {remaining, select, true {remaining } other {}}{count, plural, one {employee} other {# employees}} can be imported.',
  },
  noUsersFound: {
    id: 'app.components.AdminUsers.noUsersFound',
    defaultMessage: 'No employees to be imported.',
  },
  confirmImport: {
    id: 'app.components.AdminUsers.confirmImport',
    defaultMessage: '{count, plural, one {1 employee has } other {# employees have }} been imported.',
  },
  import: {
    id: 'app.common.import',
    defaultMessage: 'Import',
  },
});
